import React from "react";

const Sheald = () => {
  return (
    <svg
      width="15"
      height="17"
      viewBox="0 0 15 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g style={{ mixBlendMode: "luminosity" }}>
        <path
          d="M7.5 16.5C7.64062 16.5 7.85156 16.4531 8.04688 16.3438C12.5469 13.8984 14.1094 12.7656 14.1094 9.92188V4.02344C14.1094 3.08594 13.7422 2.75 12.9609 2.41406C12.0938 2.04688 9.17969 1.03125 8.32812 0.742188C8.07031 0.65625 7.76562 0.601562 7.5 0.601562C7.23438 0.601562 6.92969 0.671875 6.67188 0.742188C5.82031 0.984375 2.90625 2.05469 2.03906 2.41406C1.25781 2.74219 0.890625 3.08594 0.890625 4.02344V9.92188C0.890625 12.7656 2.46094 13.8828 6.94531 16.3438C7.14844 16.4531 7.35938 16.5 7.5 16.5ZM7.92188 2.17969C8.94531 2.58594 11.1719 3.375 12.3438 3.78906C12.5625 3.875 12.6172 3.99219 12.6172 4.27344V9.63281C12.6172 11.9219 11.4688 12.5391 7.94531 14.6641C7.72656 14.7969 7.61719 14.8438 7.50781 14.8438V2.09375C7.61719 2.09375 7.73438 2.11719 7.92188 2.17969Z"
          fill="#797979"
        />
      </g>
    </svg>
  );
};

export default Sheald;
